import React from "react";
import styled from "styled-components";
import { lensProp, view } from "ramda";
import ImageFadeIn from "../common/BackgroundImage";
import WatermarkIcon from "../../../images/watermark.png";

const width = Math.min(600, window.screen.width);
const TOP_NINE_MARGIN = 20;
const MARGIN_BETWEEN_ITEM = 1;
const ITEM_SIZE = (width - TOP_NINE_MARGIN * (MARGIN_BETWEEN_ITEM * 2)) / 3;
const itemId = lensProp("id");
const itemUri = lensProp("previewUri");
const safeView = (lens, obj) => (obj ? view(lens, obj) : "");

export const HOLDER_WIDTH = ITEM_SIZE * 3 + MARGIN_BETWEEN_ITEM * 3;

const Grid = ({ items = [], lockedWatermark, onClickGrid }) => (
  <TopNineHolder
    lockedWatermark={lockedWatermark}
    onClick={() => {
      if (onClickGrid) {
        onClickGrid();
      }
    }}
  >
    {items.slice(0, 9).map((item, index) => (
      <ItemContainer 
        key={`gridItem-${index}`}
        noBorder={index === 2 || index === 5 || index === 8}
      >
        <TopNineItem
          backgroundImage={safeView(itemUri, item)}
        />
      </ItemContainer>
    ))}
    {lockedWatermark && <Watermark src={WatermarkIcon} className="imwatermark" />}
    {lockedWatermark && (
      <MadeWithTopNine>
        Made with <TopNineApp>topnine.app</TopNineApp>
      </MadeWithTopNine>
    )}
  </TopNineHolder>
);

const TopNineHolder = styled.div`
  background-color: white;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  height: ${({ lockedWatermark }) => (lockedWatermark ? `${HOLDER_WIDTH + 40}px` : `${HOLDER_WIDTH}px`)};
  width: ${HOLDER_WIDTH}px;
  margin: 0 ${TOP_NINE_MARGIN}px;
  margin-top: ${TOP_NINE_MARGIN}px;
  background-color: white;
  position: relative;
  justify-content: flex-start;
  align-content: start;
`;

const ItemContainer = styled.div`
  width: ${ITEM_SIZE}px;
  height: ${ITEM_SIZE}px;
  padding: ${MARGIN_BETWEEN_ITEM}px;
  /* ${props => (props.noBorder ? null : `padding-right: ${MARGIN_BETWEEN_ITEM}px;`)};
  background-color: white; */
`;

const TopNineItem = styled(ImageFadeIn)`
  width: 100%;
  height: 100%;
`;

const Watermark = styled.img`
  position: absolute;
  opacity: 0.7;
  top: 0px;
  height: 100%;
  width: 100%;
`;

const MadeWithTopNine = styled.p`
  text-align: center;
  color: #8c8c8c;
  padding-top: 6px;
  font-size: 12px;
  font-family: "Montserrat";
  font-weight: 300;
  width: 100%;
`;

const TopNineApp = styled.span`
  color: #448eff;
`;

export default Grid;
